import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=57470f38&scoped=true&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/form.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/themes/default/file.css?vue&type=style&index=1&lang=css&"
import style2 from "./FileField.vue?vue&type=style&index=2&id=57470f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57470f38",
  null
  
)

export default component.exports